import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { LoginOrSignupScreen, ProfileScreen } from '../screens';
import { Icon, TopNavigationAction } from '@ui-kitten/components';


const Stack = createStackNavigator();

export const ProfileStack = (props) => (
    <Stack.Navigator>
        {/* <Stack.Screen name='LoginOrSignup' component={LoginOrSignupScreen} options={{ title: '', headerLeft: () => <MenuAction />}} /> */}
        <Stack.Screen name='Overview' component={ProfileScreen} options={{ title: '', ...getMenuAction(true)}} />
    </Stack.Navigator>
);



const MenuIcon = (style: any) => (
    <Icon {...style} name='menu-outline' height={30} width={30} />
);


import { useNavigation } from '@react-navigation/native';
import { getMenuAction } from './shared/sidebar.menu';

function MenuAction() {
    const navigation: any = useNavigation<any>();
  
    return (
        <TopNavigationAction
            icon={MenuIcon}
            onPress={() => navigation.openDrawer()}
            style={{ marginLeft: 5, padding: 10 }}
        />
    );
}